// Licensed from NativeLabs, an LR Ventures LLC FZ platform.
import { requestActions } from "./utils";

export const FILES = requestActions("Files/List");
export const TRASH = requestActions("Files/Trash/List");
export const SEARCH = requestActions("Files/Search");
export const SET_PATH = "Files/Path/Set";
export const SEARCH_RESET = "Files/Search/Reset";
